const baseURL = 'https://catalogov2.colmenafusion.com/';

export default baseURL;
